import React, { Component } from "react";

//Material components
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import AppsGroups from "./AppsGroups";
import Apps from './Apps'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { GetAllTumbnailIcon } from '../../actions/thumbnailIconAction';
import { getResidentsByCommunity } from '../../actions/residentActions';
import {GetApps,} from '../../actions/appsActions';
import {GetGroups} from '../../actions/groupAppsActions';
import { GetIcons } from '../../actions/categoryActions'


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const validate = (values) => {
    const errors = {};

    return errors;
};

class AppsView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabValue: 0
        }
    }

    tabStyles = {
        backgroundColor: '#1f1f1f',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        color: 'white',
        fontFamily: 'Gotham-Bold',
        fontSize: '16px',
        textTransform: 'none',    
    }

    SelectedTabStyle = {
        backgroundColor: '#454446',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        color: 'white',
        fontFamily: 'Gotham-Bold',
        fontSize: '16px',
        textTransform: 'none',    
    }

    async componentDidMount(){
        this.props.GetAllTumbnailIcon();

        if(this.props.communitySelected && this.props.communitySelected._id){
            this.props.getResidentsByCommunity(this.props.communitySelected._id);
            this.props.GetGroups(this.props.communitySelected._id)
            this.props.GetApps(this.props.communitySelected._id);
            this.props.GetIcons();
        }
    }

    handleTabChange = (event, newValue) => {
        this.handleChangeIndex(newValue);
    };
    
    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };
    
    handleChangeIndex = (index) => {
        this.setState({ tabValue: index })
    };

    render(){

        return (
            <React.Fragment>
                <Grid container >
                    <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: '#2a2a2b' }}>
                        <Tabs
                            value={this.state.tabValue}
                            onChange={this.handleTabChange}
                            TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                            variant="fullWidth"
                            aria-label="full width tabs community"
                        >
                            <Tab className='setupInfoSection' label="Groups" style={(this.state.tabValue === 0) ? this.SelectedTabStyle : this.tabStyles} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true} />
                            <Tab className='setupInfoSection' label="Apps" style={(this.state.tabValue === 1) ? this.SelectedTabStyle : this.tabStyles} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true} />

                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={'x' === 'rtl' ? 'x-reverse' : 'x'}
                        index={this.state.tabValue}
                        onChangeIndex={this.handleChangeIndex}
                        style={{ width: '100%' }}
                    >
                        {/******************************************************** TabPanel Groups **************************************************************/}
                        <TabPanel id='setup_integration' className='setupInfoSection' value={this.state.tabValue} index={0} dir={'x'}>
                            <Grid container spacing={2} style={{ marginTop: '30px' }} >
                                <AppsGroups communitySelected={this.props.communitySelected}/>
                            </Grid>
                        </TabPanel>

                        {/******************************************************** TabPanel Apps **************************************************************/}
                        <TabPanel id='setup_versions' className='setupInfoSection' value={this.state.tabValue} index={1} dir={'x'}>
                            <Grid container style={{ marginTop: '30px' }} justify='space-around'  >
                                <Apps communitySelected={this.props.communitySelected}/>
                            </Grid>
                        </TabPanel>
                    </SwipeableViews>
                </Grid>
            </React.Fragment>
        ) }

}


function mapStateToProps(state, ownProps) {
    return {};
}

export default connect(mapStateToProps, {GetAllTumbnailIcon,GetIcons,getResidentsByCommunity, GetApps,GetGroups})(reduxForm({
    form: 'AppsViewForm',
    validate,
    enableReinitialize: true,
})(AppsView));